import React from "react";
import { Spinner } from "@skyportal/ui-kit";

const DocumentPreviewLoader = () => {
  return <Spinner show />;
};

export default DocumentPreviewLoader;
